import global from './global/nl.json';
import zones from './zones/nl.json';

export default {
  global,
  zones
};
